export const STOLEN_VEHICLE_COLLECTION = "POLICE_STOLEN_VEHICLES";
export const STOLEN_VEHICLE_META_COLLECTION = "POLICE_STOLEN_VEHICLE_META";
export const STOLEN_VEHICLE_META_ID = "index";

function value(dictionary, id) { return id < 0 ? null : dictionary[id]; }

export function decodeStolenVehicleYears(documents) {
  return documents.flatMap(document => document.cfsNumbers.map((cfsNumber, index) => ({
    id: `${document.year}-${cfsNumber || index}-${index}`,
    receivedYear: document.year,
    sourceDay: document.sourceDays[index],
    cfsNumber: cfsNumber || null,
    reportedDate: document.reportedDates[index] || null,
    streetName: value(document.streets, document.streetIds[index]),
    vehicleYear: document.vehicleYears[index] || null,
    vehicleMake: value(document.makes, document.makeIds[index]),
    vehicleModel: value(document.models, document.modelIds[index]),
    latitude: document.latitudes[index],
    longitude: document.longitudes[index],
  })));
}
